var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKhand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 92,
    viewBox: "0 0 90 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.4759 78.7598C49.4759 78.7598 49.3639 74.6151 49.4759 71.0305C49.5879 67.446 48.6918 63.8614 49.4759 60.5008C50.26 57.1403 49.924 57.5884 50.036 53.7797C50.148 49.9711 48.4678 44.8183 48.5798 39.6654C48.6918 34.5126 47.2248 35.7448 48.5744 31.9362C49.924 28.1276 53.1725 30.1439 55.861 30.1439C58.5494 30.1439 60.0056 30.2559 61.7979 30.2559C63.5902 30.2559 65.4945 30.3679 65.4945 32.9443C65.4945 35.5208 65.4945 40.7856 65.4945 40.7856C65.4945 40.7856 65.2499 43.7393 64.9344 44.9303C64.5984 46.2001 60.9018 46.1625 61.4619 40.6736C61.4619 40.6736 61.6061 40.0992 61.8535 39.7219C61.9763 39.5346 59.6696 37.5936 60.8453 36.4734C62.022 35.3532 61.4619 35.8568 61.4619 35.8568",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8359 38.6004C52.8359 38.6004 56.8686 39.104 57.7083 38.6004C58.5489 38.0968 59.109 37.275 58.5489 36.8637C57.7585 36.2838 55.4124 34.6233 55.4124 34.6233",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5493 36.8647H60.304",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1913 43.887C65.1913 43.887 65.6062 44.482 66.5579 44.482C67.5105 44.482 68.2946 44.3136 68.2946 43.1378C68.2946 41.9621 67.9021 40.8975 68.2946 39.3292C68.6862 37.7609 69.2463 35.241 69.0223 32.1045C68.7982 28.968 68.6862 29.192 68.7427 27.2877C68.7982 25.3834 67.9586 24.3752 65.4942 24.2076C63.0298 24.0401 58.8286 25.5519 55.1885 26.672",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0884 30.3088L64.3179 28.9673",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.988 31.0344C48.988 31.0344 48.4673 29.4151 49.9791 28.0709C51.4918 26.7266 51.5474 25.438 54.5163 24.8223C57.4843 24.2067 58.661 23.7021 60.2292 23.03C61.7975 22.3579 62.8612 21.9654 64.3174 21.5173C65.7737 21.0693 66.0542 20.3972 67.79 20.2287C69.5267 20.0602 80.2805 20.2287 80.2805 20.2287C80.2805 20.2287 84.6886 20.8273 85.937 20.7323C86.817 20.6794 87.1808 20.6185 87.8063 20.8649C88.3897 21.0944 88.905 21.9645 88.0653 23.7004C86.9962 25.9102 81.5683 25.5814 79.9444 25.593C79.9444 25.593 73.8955 26.1648 71.4866 26.1648L69.9184 26.3332L68.7426 27.0053",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1006 23.5346C58.1006 23.5346 60.0605 19.2779 60.677 17.7096C61.2927 16.1414 61.4674 15.1897 63.0885 13.1733C64.7097 11.157 65.9983 8.97222 66.5584 8.02051C66.5584 8.02051 68.003 5.78015 68.6805 4.884C69.3589 3.98786 70.255 3.20373 70.8707 2.25112C71.4863 1.29942 72.3825 0.290358 73.3351 1.69103C74.2868 3.09171 73.3906 6.05974 71.7104 8.46858C70.0301 10.8774 70.6923 10.5969 69.073 13.6214C67.4537 16.6459 67.1176 17.2616 67.1176 17.2616L65.4938 21.0146",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8818 17.8083C66.8818 17.8083 68.183 16.0295 69.9753 16.4211C71.7676 16.8127 71.7676 17.8397 71.8796 20.1553",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8796 26.3352C71.8796 26.3352 71.8232 32.8323 72.3277 33.6728C72.8313 34.5134 72.9434 36.8094 72.9434 37.4259C72.9434 38.0425 73.1118 46.8354 71.2631 49.6359C69.4152 52.4363 65.5502 55.5164 65.4946 58.9334C65.4381 62.3495 65.1021 61.8459 65.2141 64.1418C65.3261 66.4377 65.1585 71.2554 65.4946 73.7754C65.8307 76.2953 65.9427 80.1604 65.9427 81.0001",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 67.5938L20.7031 70.875V79H14.8438V50.5625H20.7031V63.4531L23.2812 59.918L30.5273 50.5625H37.7344L27.6367 63.1992L38.0273 79H31.0547L23.75 67.5938Z",
    fill: "url(#paint0_diamond)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2424 67.8929) rotate(88.0754) scale(45.1147 45.0815)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD458",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9BF2E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKhand);
export default __webpack_public_path__ + "static/media/Khand.2567a4b81c3567a5685ad3a0e9102bae.svg";
export { ForwardRef as ReactComponent };